export default __webpack_public_path__ + "static/media/Gasoline99_.965f828d.svg";